<!--
 @description 服务监控-应用详情页
 @author xiehan
 @date 2018/10/11
-->
<template>
  <div class="serverDetail__content">
    <g-back :history="history" @back="back"></g-back>
    <el-tabs v-model="activeName" type="border-card">
      <!-- 当前告警tab -->
      <el-tab-pane :label="$t('serverMonitor.currentAlarm')" name="alarm">
        <server-detail-alarm-tab :app="app" :group="group"></server-detail-alarm-tab>
      </el-tab-pane>
      <!-- 应用状态tab -->
      <el-tab-pane :label="$t('serverMonitor.appStatus')" name="status">
        <server-detail-status-tab :app="app" :group="group" :active="activeName"></server-detail-status-tab>
      </el-tab-pane>
      <!-- 性能指标tab -->
      <el-tab-pane :label="$t('serverMonitor.performance')" name="performance">
        <server-detail-performance-tab :app="app" :group="group" :active="activeName"></server-detail-performance-tab>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import SiteListBiz from '@/logic/cmdb/cmdbBiz'
  import serverDetailAlarmTab from '@/views/component/serverMonitor/serverDetailAlarmTab.vue'
  import serverDetailStatusTab from '@/views/component/serverMonitor/serverDetailStatusTab.vue'
  import serverDetailPerformanceTab from '@/views/component/serverMonitor/serverDetailPerformanceTab.vue'
  export default {
    data () {
      return {
        history: [],
        app: '',
        group: '',
        activeName: 'alarm',
        siteList: {}
      }
    },
    methods: {
      getSiteList () {
        SiteListBiz.siteList({perPageCount: 500}).then((data) => {
          let list = {}
          data.dataList.map((item) => {
            list[item.siteCode] = item.name
          })
          this.siteList = list
          this.setHistory()
        })
      },
      init () {
        this.app = this.$route.query.app
        this.group = this.$route.query.group
        this.setHistory()
        this.activeName = 'alarm'
      },
      setHistory () {
        this.history = []
        this.history.push({
          name: `${this.$t('serverMonitor.serverMonitor')}(${this.siteList[this.$route.query.siteCode]})`
        }, {
          name: this.group,
          path: `/home/serverMonitor/serverAppList?group=${this.group}&siteCode=${this.$route.query.siteCode}`
        }, {
          name: this.app
        })
      },
      back (i) {
        this.app = ''
        this.activeName = 'alarm'
      }
    },
    components: {
      serverDetailAlarmTab,
      serverDetailStatusTab,
      serverDetailPerformanceTab
    },
    watch: {
      $route (to, from) {
        if (to.name === 'serverDetail' && from.name === 'serverAppList') {
          this.init()
        }
      }
    },
    mounted () {
      this.init()
      this.getSiteList()
    }
  }
</script>

<style>

</style>